/*
 * @Description: user Mutations
 */
import { MutationTree } from 'vuex'
import { MoocState,ConfigState } from '@/constant/moocTupe'
import { MoocMutationTypes } from './mutation-types'

export type Mutations<S = MoocState> = {
  [MoocMutationTypes.SET_MOOC_NAV](state: S, data: ConfigState): void
 
}

export const mutations: MutationTree<MoocState> & Mutations = {
  //导航
  [MoocMutationTypes.SET_MOOC_NAV](state: MoocState, data: ConfigState) {
    state.navConfig = data
  },
}
